import { render, staticRenderFns } from "./v-card.vue?vue&type=template&id=2ee4bda2&scoped=true&"
import script from "./v-card.vue?vue&type=script&lang=js&"
export * from "./v-card.vue?vue&type=script&lang=js&"
import style0 from "./v-card.vue?vue&type=style&index=0&id=2ee4bda2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ee4bda2",
  null
  
)

export default component.exports